import React, { JSX } from 'react';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { useColors } from '../../hooks/useColors';

export type IconProps = FontAwesomeIconProps;

export const Icon = (props: IconProps): JSX.Element => {
  const { color: _color, ...rest } = props;
  const colors = useColors();
  const color = colors[_color || ''] || _color;

  return <FontAwesomeIcon color={color} {...rest}></FontAwesomeIcon>;
};

export default Icon;
